import { useTranslation } from 'react-i18next'

import { Classified } from '../../rest/types/Classified'
import { BlockCategory } from '../../forms/AdsForm/types'
import { BlockSecretaryTransformer } from '../Transformers/BlockSecretaryTransformer'
import { BlockInstallationTransformer } from '../Transformers/BlockInstallationTransformer'
import { BlockReplacementTransformer } from '../Transformers/BlockReplacementTransformer'
import { BlockAdoptTransformer } from '../Transformers/BlockAdoptTransformer'
import { BlockJobTransformer } from '../Transformers/BlockJobTransformer'
import { BlockAssistantTransformer } from '../Transformers/BlockAssistantTransformer'
import { BlockCoordinatorTransformer } from '../Transformers/BlockCoordinatorTransformer'
import { BlockOperatingAidTransformer } from '../Transformers/BlockOperatingAidTransformer'
import { BlockPaidEmploymentTransformer } from '../Transformers/BlockPaidEmploymentTransformer'
import { BlockShareOperatingTheatreTransformer } from '../Transformers/BlockShareOperatingTheatreTransformer'
import { BlockGardeTransformer } from '../Transformers/BlockGardeTransformer'
import { BlockLiberalTransformer } from '../Transformers/BlockLiberalTransformer'
import { BlockUsedEquipmentTransformer } from 'src/relay/Transformers/BlockUsedEquipmentTransformer'

const useBlock = ({
  classified,
  classifiedUpdated,
}: {
  classified?: Classified
  classifiedUpdated?: Classified
}) => {
  const { t } = useTranslation()

  const classifiedCategory =
    classified?.classifiedCategory?.form ??
    classifiedUpdated?.classifiedCategory?.form

  const block = classified?.block?.[0] ?? classifiedUpdated?.block?.[0]

  switch (classifiedCategory) {
    case BlockCategory.Secretary:
      return BlockSecretaryTransformer({ block, t })
    case BlockCategory.Installation:
      return BlockInstallationTransformer({ block, t })
    case BlockCategory.Replacement:
      return BlockReplacementTransformer({ block, t })
    case BlockCategory.Adopt:
      return BlockAdoptTransformer({ block, t })
    case BlockCategory.Job:
      return BlockJobTransformer({ block, t })
    case BlockCategory.MedicalAssistant:
      return BlockAssistantTransformer({ block, t })
    case BlockCategory.Coordinator:
      return BlockCoordinatorTransformer({ block, t })
    case BlockCategory.OperatingAid:
      return BlockOperatingAidTransformer({ block, t })
    case BlockCategory.PaidEmployment:
      return BlockPaidEmploymentTransformer({ block, t })
    case BlockCategory.ShareOperatingTheatre:
      return BlockShareOperatingTheatreTransformer({ block, t })
    case BlockCategory.Garde:
      return BlockGardeTransformer({ block, t })
    case BlockCategory.Liberal:
      return BlockLiberalTransformer({ block, t })
    case BlockCategory.UsedEquipment:
      return BlockUsedEquipmentTransformer({ block, t })
    default:
  }
}

export default useBlock
